module.exports = __webpack_public_path__ + "static/media/post9.367fee17.PNG";